(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aufbau-compatibility-filter"] && !Shopify.designMode) return;
  try {
    if (!window.aufbauCompatibilityRoutesReady) {
 window.aufbauCompatibilityRoutesReady = true;
 document.addEventListener('change',event=>{
  if(!event.target.matches('[data-compatibility-route]')) return;
  const target=new URL(event.target.value,window.location.origin);
  const goal=window.location.pathname.split('/').pop().split('+').find(tag=>tag.startsWith('aufbau-goal-'));
  if(goal) target.pathname+=(target.pathname.split('/').filter(Boolean).length>2?'+':'/')+goal;
  target.search=window.location.search;
  window.location.assign(target.href);
 });
 document.addEventListener('click',event=>{
  if(event.button!==0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
  const link=event.target.closest('.ab-compatibility-goals a');
  if(!link||!window.location.search)return;
  event.preventDefault();const target=new URL(link.href);target.search=window.location.search;window.location.assign(target.href);
 });
}
  } catch(e) { console.error(e); }
})();

})();
